export default __webpack_public_path__ + "static/media/logo-webdev.88aae85b.svg";